module.exports = __webpack_public_path__ + "img/form-4.369acde3.png";